/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Loader from "../../components/Loader";
import { GlobalFilter } from "../../components/table/FilteringTable/GlobalFilter";
import { Table } from "antd";
import { columns } from "./components/assignUtils";
import formatError from "../../../services/FormatError";
import { getAssignBusiness } from "../../../services/RepresentativeService";
import { useTranslation } from "react-i18next";
import BusinessEvaluator from "../Summary";
import RepresentativeStatus from "../../components/representative/RepresentativeStatus";

const AssignedBusiness = () => {
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [allBusiness, setAllBusiness] = useState([]);
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [showModal, setShowModal] = useState(false);
  const [selectedBusiness, setSelectedBusiness] = useState({});

  const role = JSON.parse(sessionStorage.getItem("userDetails"))?.result;

  const { t } = useTranslation();
  useEffect(() => {
    getAllAssignBusiness();
  }, [tableParams?.current]);

  const getAllAssignBusiness = () => {
    setLoading(true);
    try {
      getAssignBusiness()
        .then((res) => {
          const response = res.data?.result ?? [];
          setAllBusiness(response ?? []);
          setTableParams((prev) => ({ ...prev, total: response?.length }));
          setLoading(false);
        })
        .catch((error) => {
          formatError(error.response?.error);
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
    }
  };
  const handleTableChange = (pagination) => {
    setTableParams(pagination);
  };

  const onHideModal = () => {
    setShowModal(false);
  };

  const filterItems = allBusiness?.filter((item) => {
    const isNameMatch =
      !searchTerm ||
      item?.domain?.toLowerCase().includes(searchTerm.toLowerCase());
    return isNameMatch;
  });
  const [summaryModal, setSummaryModal] = useState(false);
  return (
    <div class="card">
      {loading && <Loader forProcess={true} />}
      <div class="card-header d-inline">
        <div className="row">
          <div class="col-sm-12 d-flex justify-content-between d-block">
            <div class="me-auto mb-sm-0">
              <h3 class="card-title text-primary font-weight-bold">
                {t("assignedBusiness")}
              </h3>
            </div>
            {(role?.role?.id === 3 ||
              role?.role?.id === 4 ||
              role?.role?.id === 5) && (
              <div style={{ paddingLeft: "12px" }}>
                <button
                  className="btn btn-info"
                  onClick={() => setSummaryModal(true)}
                >
                  {t("businessEvaluator")}
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="row mt-2">
          <div class="col-sm-12 d-flex gap-2 justify-content-end">
            <GlobalFilter filter={searchTerm} setFilter={setSearchTerm} />{" "}
            <RepresentativeStatus />
          </div>
        </div>
      </div>
      {summaryModal && <BusinessEvaluator setShowModal={setSummaryModal} />}
      <div class="card-body">
        <Table
          columns={columns(setShowModal, setSelectedBusiness, tableParams, t)}
          rowKey={(record) => record.id}
          dataSource={filterItems}
          pagination={tableParams}
          onChange={handleTableChange}
        />
      </div>
    </div>
  );
};

export default AssignedBusiness;
